import React, { FC, useMemo } from 'react';

import clsx from 'clsx';

import { Breadcrumb, BreadcrumbWithUrl } from '@domains/breadcrumbs';

import { makeRoute } from '@utils/route';

import { Link } from '@components/common/Link/Link';
import { ChevronLeftIcon } from '@components/icons';

import styles from './Breadcrumbs.module.scss';

export type BreadcrumbsProps = {
    items: Breadcrumb[];
    isWithHomeCrumb?: boolean;
    // If present, replaces breadcrumbs with single button on mobile.
    mobileButton?: BreadcrumbWithUrl;
    className?: string;
};

export const Breadcrumbs: FC<BreadcrumbsProps> = (props) => {
    const { items, isWithHomeCrumb, mobileButton, className } = props;

    const extendedItems = useMemo<Breadcrumb[]>(
        () =>
            isWithHomeCrumb ? [{ caption: 'Главная', url: makeRoute('Home') }, ...items] : items,
        [isWithHomeCrumb, items],
    );

    return (
        <nav className={clsx(styles.root, className)}>
            <ul className={styles.list}>
                {extendedItems.map(({ caption, url }, index) => (
                    <li
                        key={`breadcrumb-${index}`}
                        className={clsx(
                            styles.listItem,
                            mobileButton !== undefined && styles.isHiddenOnMobile,
                        )}
                    >
                        {url !== undefined ? (
                            <Link route={url} className={styles.linkBreadcrumb}>
                                {caption}
                            </Link>
                        ) : (
                            <span className={styles.textBreadcrumb}>{caption}</span>
                        )}
                    </li>
                ))}

                {mobileButton !== undefined && (
                    <li
                        key="back-breadcrumb"
                        className={clsx(styles.listItem, styles.isMobileButton)}
                    >
                        <Link route={mobileButton.url} className={styles.linkBreadcrumb}>
                            <ChevronLeftIcon className={styles.backIcon} />
                            {mobileButton.caption}
                        </Link>
                    </li>
                )}
            </ul>
        </nav>
    );
};
